// src/App.js
// 앱 루트: 탭 네비게이션 + 레이아웃

import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import Header from './components/common/Header';
import TabBar from './components/common/TabBar';
import Toast from './components/common/Toast';
import HomeTab from './components/home/HomeTab';
import SendTab from './components/send/SendTab';
import CustomersTab from './components/customers/CustomersTab';
import MarketingTab from './components/marketing/MarketingTab';
import CalendarTab from './components/calendar/CalendarTab';
import SettingsTab from './components/settings/SettingsTab';
import AuthScreen from './components/auth/AuthScreen';
import ReviewPage from './components/review/ReviewPage';
import WelcomePage from './components/welcome/WelcomePage';

function AppInner() {
  const [activeTab, setActiveTab] = useState('home');
  const { state, sendToCustomer, clearPrefill } = useApp();

  // ── Firebase Auth 초기화 대기 ──
  if (state.authLoading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100dvh',
        gap: 12,
      }}>
        <div style={{ fontSize: 40 }}>🏡</div>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--green-dark)' }}>스테이메이트</div>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>불러오는 중...</div>
      </div>
    );
  }

  // ── 비로그인 → 인증 화면 ──
  if (!state.user) {
    return <AuthScreen />;
  }

  function handleSendToCustomer(customer) {
    sendToCustomer(customer);
    setActiveTab('send');
  }

  function handleSendToReservation(res) {
    sendToCustomer({
      name: res.customerName || '',
      phone: res.phone || '',
      checkin: res.checkin || '',
      checkout: res.checkout || '',
      guests: res.guests || '',
      roomId: res.roomId || '',
      channel: res.channel || '',
    });
    setActiveTab('send');
  }

  return (
    <div style={{ maxWidth: 480, margin: '0 auto', minHeight: '100dvh' }}>
      <Header />

      <div className="scroll-area">
        {activeTab === 'home' && <HomeTab onTabChange={setActiveTab} onSendToReservation={handleSendToReservation} />}
        {activeTab === 'calendar' && <CalendarTab />}
        {activeTab === 'send' && (
          <SendTab
            prefillCustomer={state.prefillCustomer}
            onClearPrefill={clearPrefill}
          />
        )}
        {activeTab === 'customers' && (
          <CustomersTab onSendToCustomer={handleSendToCustomer} />
        )}
        {activeTab === 'marketing' && <MarketingTab />}
        {activeTab === 'settings' && <SettingsTab />}
      </div>

      <TabBar activeTab={activeTab} onTabChange={setActiveTab} />
      <Toast />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/review/:token" element={<ReviewPage />} />
        <Route path="/welcome/:code" element={<WelcomePage />} />
        <Route path="*" element={
          <ErrorBoundary>
            <AppProvider>
              <AppInner />
            </AppProvider>
          </ErrorBoundary>
        } />
      </Routes>
    </BrowserRouter>
  );
}
